var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-listeners": _vm.tableListeners,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.handleCreate },
                  },
                  [_vm._v("新增")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.handleBatchRemove },
                  },
                  [_vm._v("批量移除")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colType",
            fn: function ({ row }) {
              return [
                _c("el-tag", { attrs: { size: "mini" } }, [
                  _vm._v(" " + _vm._s(_vm.getTypeName(row.block_type)) + " "),
                ]),
                _vm._v("   "),
                _c("span", [_vm._v(_vm._s(row.block_value))]),
              ]
            },
          },
          {
            key: "colMethod",
            fn: function ({ row }) {
              return [
                _vm._v(" " + _vm._s(_vm.getMethodName(row.limit_type)) + " "),
              ]
            },
          },
          {
            key: "colCreatedAt",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm._f("formatTimestamp")(row.created_at)) + " "
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c("el-popconfirm", {
                  attrs: { title: "确认移除该条黑名单？" },
                  on: {
                    confirm: function ($event) {
                      return _vm.handleRemove(row)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              { attrs: { type: "text", size: "small" } },
                              [_vm._v("移除")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("CreateBlackDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          row: _vm.editingRow,
          "type-options": _vm.typeOptions,
          "method-options": _vm.methodOptions,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          saved: _vm.handleSaved,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }